// extracted by mini-css-extract-plugin
export default {"header":"MyData_header__YB3iU"};